(function () {
  // ---- Catalog tabs (homepage catalog): All / Best Sellers / Free / category ----
  var filters = document.getElementById('filters');
  if (filters) {
    var grid = document.getElementById('grid');

    function applyFilter(b) {
      if (!b) return;
      var f = b.getAttribute('data-filter');
      filters.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      if (!grid) return;
      grid.querySelectorAll('.card').forEach(function (card) {
        var show;
        if (f === 'all') show = true;
        else if (f === '__free') show = card.getAttribute('data-free') === 'true';
        else if (f === '__bestseller') show = card.getAttribute('data-bestseller') === 'true';
        else show = card.getAttribute('data-cat') === f;
        card.style.display = show ? '' : 'none';
      });
    }

    filters.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) applyFilter(b);
    });

    // Honor the merchant's "Tab shown first" setting on load
    var def = filters.getAttribute('data-default');
    if (def && def !== 'all') {
      var db = filters.querySelector('button[data-filter="' + def + '"]');
      if (db) applyFilter(db);
    }
  }

  // ---- Live timecode in the hero monitor ----
  var tc = document.getElementById('tc');
  if (tc && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var start = Date.now();
    var z = function (n) { return String(n).padStart(2, '0'); };
    setInterval(function () {
      var t = (Date.now() - start) / 1000;
      tc.textContent = z(Math.floor(t / 3600)) + ':' + z(Math.floor((t / 60) % 60)) + ':' + z(Math.floor(t % 60)) + ':' + z(Math.floor((t * 24) % 24));
    }, 40);
  }

  // ---- Interactive product gallery ----
  var gal = document.querySelector('[data-gallery]');
  if (gal) {
    var main = gal.querySelector('#pmain');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.thumb'));
    var imgs = thumbs.length
      ? thumbs.map(function (t) { return t.getAttribute('data-full'); })
      : (main && main.getAttribute('data-full') ? [main.getAttribute('data-full')] : []);
    var current = 0;

    function setMain(i) {
      if (!main || i < 0 || i >= imgs.length) return;
      current = i;
      if (thumbs.length) {
        main.src = thumbs[i].getAttribute('data-src');
        main.setAttribute('data-full', thumbs[i].getAttribute('data-full'));
        thumbs.forEach(function (t, idx) {
          var on = idx === i;
          t.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
      }
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { setMain(idx); });
    });

    // Lightbox (built on first open)
    var overlay;
    function build() {
      overlay = document.createElement('div');
      overlay.className = 'lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image viewer');
      overlay.innerHTML =
        '<button class="lb-close" aria-label="Close">\u00D7</button>' +
        '<button class="lb-prev" aria-label="Previous image">\u2039</button>' +
        '<img class="lb-img" alt="">' +
        '<button class="lb-next" aria-label="Next image">\u203A</button>' +
        '<div class="lb-count mono" aria-live="polite"></div>';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.classList.contains('lb-close')) close();
      });
      overlay.querySelector('.lb-prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      overlay.querySelector('.lb-next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    }
    function show(i) {
      if (!imgs.length) return;
      current = (i + imgs.length) % imgs.length;
      overlay.querySelector('.lb-img').src = imgs[current];
      overlay.querySelector('.lb-count').textContent = (current + 1) + ' / ' + imgs.length;
      var single = imgs.length < 2;
      overlay.querySelector('.lb-prev').style.display = single ? 'none' : '';
      overlay.querySelector('.lb-next').style.display = single ? 'none' : '';
      setMain(current);
    }
    function open() {
      if (!imgs.length) return;
      if (!overlay) build();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      show(current);
    }
    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    var zoomBtn = gal.querySelector('[data-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', open);

    document.addEventListener('keydown', function (e) {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  }
})();
